/* External */
import axios from 'axios';
import { useEffect } from 'react';

/* Utils */
import useRequestReducer from '~/hooks/useRequestReducer';
import { PLAYER_CONFIG_URL } from '~/utils/env';
import defaultPlayerConfig from './default-player-config.json';
import { decodeSignedMessage } from './widevineDecoding';

export function createConfigMatcher(params = {}) {
  return (configsOrConfigValue, additionalParams = {}) => (
    Array.isArray(configsOrConfigValue) ? configsOrConfigValue?.find(({ match }) => (
      Object.entries(match || {}).every(([name, value]) => {
        if (value === params[name] || value === additionalParams[name]) {
          return true;
        }
        if (typeof value === 'string') {
          const regex = new RegExp(value);
          return regex.test(params[name]) || regex.test(additionalParams[name]);
        }
        return false;
      })
    ))?.value : configsOrConfigValue
  );
}

export async function getPlayerConfig() {
  if (PLAYER_CONFIG_URL) {
    try {
      const { data } = await axios.get(PLAYER_CONFIG_URL);
      return { ...defaultPlayerConfig, ...data };
    } catch (error) {
      console.error('getPlayerConfig error', error);
    }
  }
  return defaultPlayerConfig;
}

let playerConfigPromise = getPlayerConfig();
export function getCachedPlayerConfig() {
  playerConfigPromise = playerConfigPromise || getPlayerConfig();
  return playerConfigPromise;
}

export function usePlayerConfig() {
  const {
    state: { isLoading, response },
    performRequest,
  } = useRequestReducer(getCachedPlayerConfig);

  useEffect(() => {
    performRequest();
  }, [performRequest]);

  return { isLoading: isLoading || !response, config: response };
}

/**
 * Get channel path, when the user interact with MiniEPG
 * @returns {string} - The new path of the channel
 */
export function getCurrentUrlOfPlayerContent() {
  const currentPath = window.location.href;
  const playerIndex = currentPath.indexOf('/private');
  return currentPath.slice(Math.max(0, playerIndex));
}

export async function logLicenseEvent(name, data) {
  try {
    /* Loaded lazily so the RUM SDK stays out of the main bundle; addAction is
       only reachable after a license event, long after boot. */
    const { datadogRum } = await import('@datadog/browser-rum');
    datadogRum.addAction(`license:${name}`, await decodeSignedMessage(data));
  } catch (error) {
    console.error('logLicenseEvent error', error);
  }
}
